<template>

  <div class="mt-4">
    <div class="row">
      <div class="col-md-12">
        <b-card class="mt-2 mb-4 shadow-sm">
          <b-form ref="fundingRequestForm" v-unsave-detector @submit.stop.prevent="clickOnValidateBtn">
            <div class="row">
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="font-weight-bolder secondary-color h6">{{ $t('operation.dossier.step5.title') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="mb-3">{{ $t('operation.dossier.step5.subtitle') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  :invalid-feedback="form.request.invalidFeedback"
                  :label="$t('operation.dossier.field.text')"
                  :state="form.request.state"
                  class="medium-label mb-4"
                  label-for="texte-explicatif-input">
                  <VueEditor id="texte-explicatif-input" v-model="form.request.value"
                             :editorToolbar="customToolbar" v-on:input="emitChangeValue"></VueEditor>
                </b-form-group>
              </div>
              <div class="col-md-6">
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <b-button class="mr-2" variant="outline-primary" @click="back">{{ $t("Back") }}</b-button>
              <b-button type="submit" variant="primary">{{ $t("Finish") }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../../../services/api'
import {VueEditor} from "vue2-editor";

export default {
  name: "DossierOperationDemandeFinancement",
  components: {
    VueEditor
  },
  props: {
    currentStep: Number,
    dossierId: Number,
    fundingRequestCreationDone: Boolean
  },

  data() {
    return {
      financement: {},
      form: {
        request:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        ['blockquote', 'code-block'],
        [{list: "ordered"}, {list: "bullet"}],
      ]
    }
  },
  emits: ['didContinueDemande', 'didBack', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      if (this.dossierId && this.fundingRequestCreationDone) {
        await this.fetchDemandeFinancement()
        this.setInitialValues()
      }
    },

    async fetchDemandeFinancement() {
      await api
        .get(`/fundingRequest/getFundingRequestByDossier/${this.dossierId}`)
        .then(response => {
          this.financement = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    setInitialValues() {
      if (this.dossierId != null) {
        if (this.financement.request && !this.financement.request.includes('null')) {
          this.form.request.value = this.financement.request
        }
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    /** Bouton validate (Etape suivante)
     *  save + redirection vers l'étape 2 de la création d'operation + success toast
     */
    clickOnValidateBtn() {
      if (!this.$refs["fundingRequestForm"].reportValidity()) {
        return;
      }
      this._save(response => {
        this.$emit('didContinueDemande', response.data.id)
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.form.request.value, 'f.added')
        })
      })
    },

    /** Bouton save (Sauvegarder)
     *  save + success toast (pas de redirection)
     */


    /** Enregistrement des infos de l'operation en db
     *  POST si l'operation n'existe pas - PUT si c'est une modification (type d'operation non modifiable)
     * @param onSuccessClosure (effectuée si l'enregistrement en db fonctionne)
     */
    _save(onSuccessClosure) {
      let data = new FormData()
      data.append('dossierId', this.dossierId)
      data.append('request', this.form.request.value)

      api({
        method: this.financement.id ? 'PUT' : 'POST',
        url: this.financement.id ? `fundingRequest/${this.financement.id}` : 'fundingRequest',
        data: data
      })
        .then((response) => {
          if (onSuccessClosure) onSuccessClosure(response)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {

            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    /** Success toast quand l'operation est créée/modifiée
     */
    successToast(operationName, actionName) {
      this.$bvToast.toast("Situation opération" + this.$i18n.t(actionName), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    back() {
      this.$emit("didBack")
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationDossier/dossierOperationCreateSteps/DossierOperationDemandeFinancement.vue